import React from 'react';
import classSet from 'classnames';
import Utils from 'react-bootstrap-table/lib/util';
import Const from 'react-bootstrap-table/lib/Const';
import TableBody from 'react-bootstrap-table/lib/TableBody';
import TableRow from './TableRow';
import TableColumn from 'react-bootstrap-table/lib/TableColumn';
import TableEditColumn from 'react-bootstrap-table/lib/TableEditColumn';
import ExpandComponent from 'react-bootstrap-table/lib/ExpandComponent';

//this table uses virtual load on scroll solution,
//provided in these 2 pull requests
// https://github.com/AllenFang/react-bootstrap-table/pull/566/commits/aaff23d4d2e1225451d07d6cabe4d679453b6a52
// https://github.com/AllenFang/react-bootstrap-table/pull/566/commits/e75642b6af9d5471f2a85411bbcb912f31b99da9

export default class TableBodyWithContextMenu extends TableBody {
  constructor(props) {
    super(props);
    this.state = {
      currEditCell: null,
      scrollTop: 0
    };
    this.availableHeight = 0;
    this.editing = false;
    this.emptyTableRowHeight = {
      height: 64,
      visibility: 'hidden'
    };
  }

  componentDidMount() {
    // if (this.refs.tbody) {
    // this.emptyTableRowHeight = Object.assign({}, this.emptyTableRowHeight, {height: this.refs.tbody.childNodes[1].offsetHeight || 64});
    // this.refs.tbody.addEventListener('scroll', this._handleTableScroll);
    // this.availableHeight = this.refs.tbody.clientHeight;
    // this.forceUpdate();
    // }
  }

  componentDidUpdate() {
    // if (this.refs.tbody && this.availableHeight !== this.refs.tbody.clientHeight) {
    //   this.emptyTableRowHeight = Object.assign({}, this.emptyTableRowHeight, {height: this.refs.tbody.childNodes[1].offsetHeight || 64});
    //   this.availableHeight = this.refs.tbody.clientHeight;
    // this.forceUpdate(); // Maximum update depth exceeded when adding many rows
    // }
  }

  componentWillUnmount() {
    if (this.refs.tbody) {
      this.refs.tbody.removeEventListener('scroll', this._handleTableScroll);
    }
  }

  // _handleTableScroll = (e) => {
  //   this.availableHeight = e.target.clientHeight;
  //   const maxScroll = this.props.data.length * this.emptyTableRowHeight.height;
  //   this.setState({
  //     scrollTop: e.target.scrollTop <= maxScroll ? e.target.scrollTop : maxScroll
  //   });
  // }

  render() {
    const { cellEdit, beforeShowError, x, y, keyBoardNav, trStyle, contextMenuId } = this.props;
    const tableClasses = classSet('table', {
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    }, this.props.tableBodyClass);

    const noneditableRows = (cellEdit.nonEditableRows && cellEdit.nonEditableRows()) || [];
    const unselectable = this.props.selectRow.unselectable || [];
    const isSelectRowDefined = this._isSelectRowDefined();
    const tableHeader = Utils.renderColGroup(this.props.columns,
      this.props.selectRow, this.props.expandColumnOptions);
    const inputType = this.props.selectRow.mode === Const.ROW_SELECT_SINGLE ? 'radio' : 'checkbox';
    const CustomComponent = this.props.selectRow.customComponent;
    const enableKeyBoardNav = (keyBoardNav === true || typeof keyBoardNav === 'object');
    const customEditAndNavStyle = typeof keyBoardNav === 'object'
      ? keyBoardNav.customStyleOnEditCell
      : null;
    const customNavStyle = typeof keyBoardNav === 'object'
      ? keyBoardNav.customStyle
      : null;
    const ExpandColumnCustomComponent = this.props.expandColumnOptions.expandColumnComponent;

    //calculate number of rows to display in available height
    let RowEndIndex = this.props.data.length - 1;
    let RowStartIndex = 0;
    // const tBodyHeight = this.refs.tbody ? this.refs.tbody.clientHeight : window.innerHeight;
    // if (this.props.data.length > 15) {
    //   const rowHeight = this.emptyTableRowHeight.height;
    //   RowIndex = Math.max(0, Math.floor(this.state.scrollTop / rowHeight));
    //   const viewItems = Math.ceil((this.availableHeight || tBodyHeight) / rowHeight);
    //   RowEndIndex = Math.min(this.props.data.length, RowIndex + viewItems) - 1;
    // } else {
    // RowEndIndex = this.props.data.length - 1;
    // RowIndex = 0;
    // }
    const topSpace = (this.emptyTableRowHeight.height * RowStartIndex) || 0;
    const bottomSpace = (this.emptyTableRowHeight.height * (this.props.data.length - 1 - RowEndIndex)) || 0;
    //end calculating

    let expandColSpan = this.props.columns.filter(col => col && !col.hidden).length;
    if (isSelectRowDefined && !this.props.selectRow.hideSelectColumn) {
      expandColSpan += 1;
    }
    let tabIndex = 1;
    if (this.props.expandColumnOptions.expandColumnVisible) {
      expandColSpan += 1;
    }
    // if (contextMenu) {
    //   const contextMenuItem = contextMenu.items.map((item, i) => {
    //     return <MenuItem key={i} onClick={this.onClickMenuItem}>{item}</MenuItem>;
    //   });
    //   // const contextMenuTrigger = <ContextMenuTrigger id={contextMenu.id} collect={this.collectRow} />;
    // }
    let tableRows = this.props.data.map((data, r) => {
      // display dummy row for data not in the view
      if ((r < RowStartIndex) || r > RowEndIndex) {
        // return <tr style={ this.emptyTableRowHeight } key={ r }><td /></tr>;
        return null;
      }
      //end display dummy row

      const tableColumns = this.props.columns.filter(_ => _ !== null).map((column, i) => {
        const fieldValue = data[column.name];
        const isFocusCell = r === y && i === x;
        if (column.name !== this.props.keyField && // Key field can't be edit
          column.editable && // column is editable? default is true, user can set it false
          column.editable.readOnly !== true &&
          this.state.currEditCell !== null &&
          this.state.currEditCell.rid === r &&
          this.state.currEditCell.cid === i &&
          noneditableRows.indexOf(data[this.props.keyField]) === -1) {
          let editable = column.editable;
          const format = column.format ? (value) => {
            return column.format(value, data, column.formatExtraData, r).replace(/<.*?>/g, '');
          } : false;
          if (Utils.isFunction(column.editable)) {
            editable = column.editable(fieldValue, data, r, i);
          }

          return (
            <TableEditColumn
              completeEdit={ this.handleCompleteEditCell }
              // add by bluespring for column editor customize
              editable={ editable }
              customEditor={ column.customEditor }
              format={ column.format ? format : false }
              key={ i }
              blurToSave={ cellEdit.blurToSave }
              onTab={ this.handleEditCell }
              rowIndex={ r }
              colIndex={ i }
              row={ data }
              fieldValue={ fieldValue }
              className={ column.editClassName }
              invalidColumnClassName={ column.invalidEditColumnClassName }
              beforeShowError={ beforeShowError }
              isFocus={ isFocusCell }
              customStyleWithNav={ customEditAndNavStyle } />
          );
        } else {
          // add by bluespring for className customize
          let columnChild = fieldValue && fieldValue.toString();
          let columnTitle = null;
          let tdClassName = column.className;
          if (Utils.isFunction(column.className)) {
            tdClassName = column.className(fieldValue, data, r, i);
          }

          if (typeof column.format !== 'undefined') {
            const formattedValue = column.format(fieldValue, data, column.formatExtraData, r);
            if (!React.isValidElement(formattedValue)) {
              columnChild = (
                <div dangerouslySetInnerHTML={ { __html: formattedValue } } />
              );
            } else {
              columnChild = formattedValue;
              columnTitle = column.columnTitle && formattedValue ? formattedValue.toString() : null;
            }
          } else {
            columnTitle = column.columnTitle && fieldValue ? fieldValue.toString() : null;
          }
          return (
            <TableColumn key={ i }
              rIndex={ r }
              dataAlign={ column.align }
              className={ tdClassName }
              columnTitle={ columnTitle }
              cellEdit={ cellEdit }
              hidden={ column.hidden }
              onEdit={ this.handleEditCell }
              width={ column.width }
              onClick={ this.handleClickCell }
              attrs={ column.attrs }
              style={ column.style }
              tabIndex={ (tabIndex++) + '' }
              isFocus={ isFocusCell }
              keyBoardNav={ enableKeyBoardNav }
              onKeyDown={ this.handleCellKeyDown }
              customNavStyle={ customNavStyle }
              row={ data }
              withoutTabIndex={ this.props.withoutTabIndex }>
              { columnChild }
            </TableColumn>
          );
        }
      }, this);
      const key = data[this.props.keyField] ? data[this.props.keyField] : data.toString();
      const disable = unselectable.indexOf(key) !== -1;
      const selected = this.props.selectedRowKeys.indexOf(key) !== -1;
      const selectRowColumn = isSelectRowDefined && !this.props.selectRow.hideSelectColumn
        ? this.renderSelectRowColumn(selected, inputType, disable, CustomComponent, r, data) : null;
      const expandedRowColumn = this.renderExpandRowColumn(
        this.props.expandableRow && this.props.expandableRow(data),
        this.props.expanding,
        ExpandColumnCustomComponent, r, data
      );
      const haveExpandContent = this.props.expandableRow && this.props.expandableRow(data);
      const isExpanding = haveExpandContent && this.props.expanding;

      // add by bluespring for className customize
      let trClassName = this.props.trClassName;
      if (Utils.isFunction(this.props.trClassName)) {
        trClassName = this.props.trClassName(data, r);
      }
      if (isExpanding && this.props.expandParentClass) {
        trClassName += Utils.isFunction(this.props.expandParentClass)
          ? this.props.expandParentClass(data, r)
          : this.props.expandParentClass;
      }

      const result = [<TableRow isSelected={ selected } key={ key } className={ trClassName }
        id={key}
        index={ r }
        row={ data }
        contextMenuId={contextMenuId}
        selectRow={ isSelectRowDefined ? this.props.selectRow : undefined }
        enableCellEdit={ cellEdit.mode !== Const.CELL_EDIT_NONE }
        onRowClick={ this.handleRowClick }
        onRowDoubleClick={ this.handleRowDoubleClick }
        onRowMouseOver={ this.handleRowMouseOver }
        onRowMouseOut={ this.handleRowMouseOut }
        onSelectRow={ this.handleSelectRow }
        onExpandRow={ this.handleClickCell }
        unselectableRow={ disable }
        style={ trStyle }>
        { this.props.expandColumnOptions.expandColumnVisible &&
                this.props.expandColumnOptions.expandColumnBeforeSelectColumn &&
                expandedRowColumn }
        { selectRowColumn }
        { this.props.expandColumnOptions.expandColumnVisible &&
                !this.props.expandColumnOptions.expandColumnBeforeSelectColumn &&
                expandedRowColumn }
        { tableColumns }
      </TableRow>];

      if (haveExpandContent) {
        const expandBodyClass = Utils.isFunction(this.props.expandBodyClass)
          ? this.props.expandBodyClass(data, r, isExpanding)
          : this.props.expandBodyClass;
        result.push(
          <ExpandComponent
            key={ key + '-expand' }
            row={ data }
            className={ expandBodyClass }
            bgColor={ this.props.expandRowBgColor || this.props.selectRow.bgColor || undefined }
            hidden={ !isExpanding }
            colSpan={ expandColSpan }
            width={ '100%' }>
            { this.props.expandComponent(data) }
          </ExpandComponent>
        );
      }
      return (result);
    }, this);

    if (tableRows.length === 0 && !this.props.withoutNoDataText) {
      const colSpan = this.props.columns.filter(c => !c.hidden).length +
        ((isSelectRowDefined && !this.props.selectRow.hideSelectColumn) ? 1 : 0) +
        (this.props.expandColumnOptions.expandColumnVisible ? 1 : 0);
      tableRows = [
        <TableRow key='##table-empty##' style={ trStyle }>
          <td data-toggle='collapse'
            colSpan={ colSpan }
            className='react-bs-table-no-data'>
            { this.props.noDataText || Const.NO_DATA_TEXT }
          </td>
        </TableRow>
      ];
    }

    return (
      <div ref='container'
        className={ classSet('react-bs-container-body', this.props.bodyContainerClass) }
        style={ this.props.style }>
        <table className={ tableClasses }>
          { React.cloneElement(tableHeader, { ref: 'header' }) }
          <tbody ref='tbody'>
            <tr style={{height: topSpace}}/>
            { tableRows }
            <tr style={{height: bottomSpace || 1}}/>
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReactBootstrapTable/TableBody.js